import { Component, OnInit, Inject, Injectable, LOCALE_ID } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: "root"
})
export  class GlobalConstants {
    client: string;
    data: any;
    constructor(@Inject(DOCUMENT) private document: any, private router: Router, @Inject(LOCALE_ID) public locale: string,) {
        var subDomain = this.document.location.hostname.split("www.").join("").split(".", 1);
        subDomain = subDomain.join("").split("sandbox-").join("").split(".", 1);
        const selectedCountry = JSON.parse(localStorage?.getItem('userCountry') as any);

        if (this.document.location.hostname.includes("citi")) {
            this.client = "citi";
        }
        else if(this.document.location.hostname.includes("mastercard")){
          this.client = "mastercard";
        }
        else if(this.document.location.hostname.includes("smeoffers") || this.document.location.hostname.includes("visaoffers-beta")){
            this.client = "smeoffers";
          }
        switch (this.client) {
                case "citi":
                this.data = {
                    "logo": {
                        "url": "https://images.poshvine.com/logos/citi-new.png",
                        "footerurl": "https://images.poshvine.com/logos/citi-small.png",
                        "desktop_url": "https://images.poshvine.com/logos/citi-new.png",
                        "modal_url": "https://images.poshvine.com/logos/citi-new.png",
                        "favicon": "https://images.poshvine.com/favicon/citi.ico",
                        "head_logo_height": "42",
                        "coupon_modal_logo": "https://images.poshvine.com/logos/citi-new.png"
                    },
                    "assets": {
                        "img": {
                          "banner": [
                              {'img': 'https://s3.ap-south-1.amazonaws.com/images.poshvine.com/b/citi-main-b.png', 'id': '','tagline': '', 'subTagline': ""},
                              ]
                        },
                        'client_css': 'citi.scss',
                        "manifest": "manifest.webmanifest"
                    },
                    "links": {
                        "projectLink": "https://citi.poshvine.com/"
                    },
                    "colors": {
                        "header_bg_color": "#055597",
                        "coupon_modal_bg_color": "#195993",
                        "offer_title_color": '#195993',
                        "main_text_color": '#262626',
                        "medium_text_color": '#5C5C5C',
                        "light_text_color": '#9D9D9D',
                        "main_bg_color": '#F4F4F4',
                        "active_card_bg_color": '#F4F4F4',
                        "seconday_bg_color": '#FDFCFA',
                        "mainBtn_color": '#ed8320',
                        "inactive_btn_color": '#D8D8D8',
                        "btn_positive_action_color": '#195993',
                        "active_text_color": '#195993',
                        "redeem_btn_color": '#00429466'
                    },
                    "legal_name" : "Citi Lifestyle Benefits",
                    "font_family": {
                      "link": "https://images.poshvine.com/fonts/interstate/Interstate.css",
                      "name": "Interstate"
                    },
                    "x_header": {
                            "prod": {
                                'client_id': '10f358ea-d651-4d2c-b969-f33d79f83c71',
                                'main_project': 'e4371739-752a-4156-a3e1-b6629a07b687',
                                'sub_project': 'a6a55986-d69d-4b91-ab5f-4168c787c9ab'
                            },
                            "sandbox": {
                                'client_id': '10f358ea-d651-4d2c-b969-f33d79f83c71',
                                'main_project': 'a6a55986-d69d-4b91-ab5f-4168c787c9ab',
                                'sub_project': 'a6a55986-d69d-4b91-ab5f-4168c787c9ab'
                            },
                            "default_card_type": 'credit'
                    },
                    "email_needed": true,
                    "homepage_needed": true,
                    "search_type": 1,
                    "desktop_category_count": 5,
                    "card_num_type": 'first6',
                    "card_type": "Debit/Credit",
                    "tabs_type": "subcategory",
                    "tabs_type_mobile": "subcategory",
                    "has_exclusive": false,
                    "banner_type": "static",
                    "login_button_needed": true,
                    "loginAt": "otp",
                    "login_theme": 1,
                    "login_steps": ['card','mobile','otp'],
                    "auto_expiry": {
                        "time" : "",
                        "enabled" : false
                    },
                    "template" : 1,
                    "header_type": "default",
                    "show_saving_for_bundle_codes": {},
                    "download_app_link": {
                        'header': false,
                        'footer': false,
                        'android_link': '',
                        'apple_link': ''
                    },
                    "login_modal_type": "desktop-prev-header",
                    "supported_devices": ['web','mobile'],
                    "benefits":['offers'],
                    "banner_style": 1,
                    "carouselInterval": -1,
                    "api_version": 'v2',
                    "personalized_config": {
                        "coupon_terms_link": false,
                        "switch_card": false,
                        "autocard_check": false,
                        "view_savings": true,
                        "external_otp": false,
                        "redemption_page_needed": true,
                        "saving_page": false,
                        "resend_allowed": true,
                        "add_new_card": true,
                        "footer_logo": false,
                        "force_auth": false,
                        "token_auth": false,
                        "desktop_search": true,
                        "mobile_search": true,
                        "auth": true,
                        "coupon_modal": true,
                        "coupon_show": true,
                        "amount_show": false,
                        "modal_redeem_button": true,
                        "mobile_home_back_button": true,
                        "show_card_used": false,
                        "show_bundle_used": false,
                        "allow_user_create": true,
                        "dedicated_banner": false,
                        "mobile_banner": true,
                        "authenticate_before_claim": true,
                        "disclaimer_popup": false,
                        "cancelable_auth": true,
                        "display_bundle_category_title": true,
                        "mobile_login": true,
                        "is_concierge": false,
                        "has_card": true,
                        "home_subcategory_dropdown": false,
                        "home_subcategory_bar": false,
                        "has_near_by": false,
                        "has_international": false,
                        "mobile_profile_dropdown": true,
                        "category_page": true,
                        "authenticate_bin": true,
                        "datalayer": false,
                        "custom_gtm_tags": false,
                        "show_terms_before_redeem": false,
                        "details_desktop_tabs": false,
                        "show_special_category": false,
                        "send_project_id": true,
                        "show_card_applicability": false,
                        "card_applicability_fetch": 'api',
                        "show_card_select_on_auth": false,
                        "special_bundle": false,
                        "external_login_banner": false,
                        "has_international_offers": false,
                        "redemption_page_display_card_number": true,
                        "has_add_card_text": false,
                        "send_as_gift": false,
                        "applicableTag": false,
                        "has_maps": false
                    },
                    "subProjectLinks": [
                      'paytm-wellnessoffers'
                    ],
                    "titles": {
                        "homepage_pagetitle": "Citi Lifestyle Benefits",
                        "homepage_description": "",
                        "homepage_keywords": "",
                        "header_title": "",
                        "modal_mobile_label": $localize`Enter your mobile number registered with Citibank`,
                        "card_name" : "Citibank card",
                        "platform_title": "Citi Lifestyle Benefits",
                        "concierge_name": "Citi Lifestyle Benefits",
                        "login_modal_control": $localize`Validate Your Mobile Number`
                    },
                    "footer_additional_content": "<p>Disclaimer: This platform is curated for communication of personalized offers extended by Merchants to Citibank's Customers. This platform is only communicating the offers extended by Merchants to its Customers and not Selling/Rendering any of these Products/Services. The platform neither guarantees nor makes any representation. This platfrom is not responsible for Sale/Quality/Features of the Products/Services under the offers.</p><p>Site is best viewed in Chrome V23+, Firefox V15+, Safari 6+ and IE11+ at 1024 x 768 pixels resolution, or above.</p>",
                    "content":{
                        "bin_error": {
                            "first4_last4": $localize`Dear customer, please re-check the first 4 and last 4 digits of the card number you have entered`,
                            "first6": $localize`Dear customer, please re-check the first 6 digits of your card number you have entered`
                        },
                        "bin_invalid": {
                            "first4_last4": $localize`Please enter your valid first 4 and last 4 digits of your debit card correctly. In case the issue persists, write to support-poshvine@razorpay.com`,
                            "first6": $localize`Invalid Card`
                        }
                    },
                    "email": {
                        display: 'support-poshvine@razorpay.com', val: 'support-poshvine@razorpay.com'
                    },
                };
                break;
                case "mastercard":
                this.data = {
                    "logo": {
                        "url": "https://images.poshvine.com/logos/mc-logo-52.svg",
                        "footerurl": "https://images.poshvine.com/logos/mc-logo-52.svg",
                        "desktop_url": "https://images.poshvine.com/logos/mc-logo-52.svg",
                        "modal_url": "https://images.poshvine.com/logos/mc-logo-52.svg",
                        "favicon": "https://images.poshvine.com/logos/mc-logo-52.svg",
                        "head_logo_height": "42",
                        "coupon_modal_logo": "https://images.poshvine.com/logos/mc-logo-52.svg"
                    },
                    "assets": {
                        "img": {},
                        'client_css': 'citi.scss',
                        "manifest": "manifest.webmanifest"
                    },
                    "links": {
                        "projectLink": "https://mastercard.poshvine.com/"
                    },
                    "colors": {
                        "header_bg_color": "#141413",
                        "coupon_modal_bg_color": "#141413",
                        "offer_title_color": '#EE5E36',
                        "main_text_color": '#EE5E36',
                        "medium_text_color": '#5C5C5C',
                        "light_text_color": '#9D9D9D',
                        "main_bg_color": '#F4F4F4',
                        "active_card_bg_color": '#F4F4F4',
                        "seconday_bg_color": '#FDFCFA',
                        "mainBtn_color": '#EE5E36',
                        "inactive_btn_color": '#D8D8D8',
                        "btn_positive_action_color": '#195993',
                        "active_text_color": '#EE5E36',
                        "redeem_btn_color": '#00429466'

                    },
                    "legal_name" : "Mastercard",
                    "font_family": {
                      "link": "https://images.poshvine.com/fonts/interstate/Interstate.css",
                      "name": "Interstate"
                    },
                    "x_header": {
                            "prod": {
                                'client_id': '2a0127dc-09f0-4135-878a-d2378503f6cb',
                                'main_project': '3ba1b73d-ab08-4f53-bd77-ea2226c61a7f',

                            },
                            "sandbox": {
                                'client_id': '10f358ea-d651-4d2c-b969-f33d79f83c71',
                                'main_project': 'a6a55986-d69d-4b91-ab5f-4168c787c9ab',

                            },
                            "default_card_type": 'credit'
                    },
                    "email_needed": false,
                    "homepage_needed": false,
                    "search_type": 1,
                    "desktop_category_count": 5,
                    "card_num_type": 'first8',
                    "card_type": "Debit/Credit",
                    "tabs_type": "subcategory",
                    "tabs_type_mobile": "subcategory",
                    "has_exclusive": false,
                    "banner_type": "static",
                    "login_button_needed": true,
                    "loginAt": "otp",
                    "login_theme": 1,
                    "login_steps": ['card','mobile','otp'],
                    "auto_expiry": {
                        "time" : "",
                        "enabled" : false
                    },
                    "template" : 1,
                    "header_type": "mastercard",
                    "show_saving_for_bundle_codes": {},
                    "download_app_link": {
                        'header': false,
                        'footer': false,
                        'android_link': '',
                        'apple_link': ''
                    },
                    "login_modal_type": "desktop-prev-header",
                    "supported_devices": ['web','mobile'],
                    "benefits":['offers'],
                    "banner_style": 1,
                    "carouselInterval": -1,
                    "api_version": 'v2',
                    "personalized_config": {
                        "coupon_terms_link": false,
                        "switch_card": false,
                        "autocard_check": false,
                        "view_savings": false,
                        "external_otp": false,
                        "redemption_page_needed": false,
                        "saving_page": false,
                        "resend_allowed": true,
                        "add_new_card": false,
                        "footer_logo": false,
                        "force_auth": false,
                        "token_auth": false,
                        "desktop_search": true,
                        "mobile_search": true,
                        "auth": true,
                        "coupon_modal": true,
                        "coupon_show": true,
                        "amount_show": false,
                        "modal_redeem_button": true,
                        "mobile_home_back_button": true,
                        "show_card_used": false,
                        "show_bundle_used": false,
                        "allow_user_create": true,
                        "dedicated_banner": false,
                        "mobile_banner": true,
                        "authenticate_before_claim": true,
                        "disclaimer_popup": false,
                        "cancelable_auth": true,
                        "display_bundle_category_title": true,
                        "mobile_login": true,
                        "is_concierge": false,
                        "has_card": true,
                        "home_subcategory_dropdown": false,
                        "home_subcategory_bar": false,
                        "has_near_by": false,
                        "has_international": false,
                        "mobile_profile_dropdown": true,
                        "category_page": true,
                        "authenticate_bin": true,
                        "datalayer": false,
                        "custom_gtm_tags": false,
                        "show_terms_before_redeem": false,
                        "details_desktop_tabs": false,
                        "show_special_category": false,
                        "send_project_id": true,
                        "show_card_applicability": false,
                        "card_applicability_fetch": 'api',
                        "show_card_select_on_auth": false,
                        "special_bundle": false,
                        "external_login_banner": false,
                        "has_international_offers": false,
                        "redemption_page_display_card_number": true,
                        "has_add_card_text": false,
                        "send_as_gift": false,
                        "applicableTag": false,
                        "has_maps": false
                    },
                    "subProjectLinks": [
                      'paytm-wellnessoffers'
                    ],
                    "titles": {
                        "homepage_pagetitle": "Mastercard Benefits",
                        "homepage_description": "",
                        "homepage_keywords": "",
                        "header_title": "",
                        "modal_mobile_label": $localize`Enter your mobile number registered with Mastercard`,
                        "card_name" : "Mastercard",
                        "platform_title": "Mastercard Benefits",
                        "concierge_name": "Mastercard Benefits",
                        "login_modal_control": $localize`Validate Your Mobile Number`
                    },
                    "footer_additional_content": "<p>Disclaimer: This platform is curated for communication of personalized offers extended by Merchants to Mastercard's Customers. This platform is only communicating the offers extended by Merchants to its Customers and not Selling/Rendering any of these Products/Services. The platform neither guarantees nor makes any representation. This platfrom is not responsible for Sale/Quality/Features of the Products/Services under the offers.</p><p>Site is best viewed in Chrome V23+, Firefox V15+, Safari 6+ and IE11+ at 1024 x 768 pixels resolution, or above.</p>",
                    "content":{
                        "bin_error": {
                            "first8": $localize`Dear customer, please re-check the first 8 digits of the card number you have entered`,
                        },
                        "bin_invalid": {
                            "first8": $localize`Please enter your valid first 8 digits of your card correctly. In case the issue persists, write to support-poshvine@razorpay.com`,

                        }
                    },
                    "email": {
                        display: 'support-poshvine@razorpay.com', val: 'support-poshvine@razorpay.com'
                    },
                };
                break;
                case "smeoffers":
                this.data = {
                    "logo": {
                        // "url": "https://images.poshvine.com/logos/sme-offer-white-log.png",
                        "footerurl": "https://images.poshvine.com/logos/sme-offer-black-logo.png",
                        "desktop_url": "https://images.poshvine.com/visa-contactless/visa-logo.png",
                        // "desktop_url_mobile": "https://images.poshvine.com/logos/sme-offer-white-log.png",
                        // "desktop_url": "https://images.poshvine.com/logos/sme-offer-white-log.png",
                        "modal_url": "https://images.poshvine.com/logos/sme-offer-black-logo.png",
                        "favicon": "./assets/favicon/sme.ico",
                        "head_logo_height": "30",
                        "coupon_modal_logo": "https://images.poshvine.com/visa-contactless/visa-logo.png",
                        "visa_logo": "https://images.poshvine.com/visa-contactless/visa-logo.png",
                        "visa_logo_height": '30',
                        "visa_logo_height_mobile": '15'
                    },
                    "assets": {
                        "img": {
                            "banner": [
                                {'attributes':
                                {"banner_image": 'https://assets.poshvine.com/merchants/visa/sme-offers/images/two-people-cooking-together.avif', 'id': '','tagline': '', 'subTagline': '', "name": 'SME Offers Banner'}}
                              ],
                              "visa_secure": {"img":"https://images.poshvine.com/visa/visa-secure.png", "name": "Visa Secure", "height": "60", "width": "60"}
                            },
                            "manifest": "manifest.webmanifest"
                          },
                    "categories": {
                      "marketing": { name: "Marketing", logo_url: "https://images.poshvine.com/visa/marketing.png" },
                      "productivity": { name: "Productivity", logo_url: "https://images.poshvine.com/visa/productivity.png" },
                      "cloud-infrastructure": { name: "Cloud Infrastructure", logo_url: "https://images.poshvine.com/visa/cloud-infrastructure.png" },
                      "hr-learning": { name: "HR & Learning", logo_url: "https://images.poshvine.com/visa/hr-learning.png" },
                      "customer-support": { name: "Customer Support", logo_url: "https://images.poshvine.com/visa/customer-support.png" },
                      "business-travel": { name: "Business Travel", logo_url: "https://images.poshvine.com/visa/business-travel.png" },
                      "business-solutions": { name: "Business Solutions", logo_url: "https://images.poshvine.com/visa/business-solutions.png" },
                      "workspaces": { name: "Workspaces", logo_url: "https://images.poshvine.com/visa/workspaces.png" },
                      "finance": { name: "Finance", logo_url: "https://images.poshvine.com/visa/finance.png" },
                      "logistics": { name: "Logistics", logo_url: "https://images.poshvine.com/visa/logistics.png" },
                    },
                    "links": {
                        "projectLink": "https://smeoffers.poshvine.com/"
                    },
                    "colors": {
                        "header_bg_color": "#FFFFFF",
                        "coupon_modal_bg_color": "#FFFFFF",
                        "offer_title_color": '#1A1F71',
                        "main_text_color": '#262626',
                        "medium_text_color": '#5C5C5C',
                        "light_text_color": '#9D9D9D',
                        "main_bg_color": '#F4F4F4',
                        "active_card_bg_color": '#F4F4F4',
                        "seconday_bg_color": '#FDFCFA',
                        "mainBtn_color": '#1434CB',
                        "inactive_btn_color": '#D8D8D8',
                        "btn_positive_action_color": '#003ea9',
                        "active_text_color": '#274896',
                        "redeem_btn_color": '#bcbebf'
                    },
                    "legal_name" : "SME Offers",
                    "font_family": {
                        "link": "https://images.poshvine.com/fonts/sf-ui-display/sf-ui-display.css",
                        "name": "SF UI Display"
                    },
                    "x_header": {
                            "prod": {
                                'client_id': '3825376c-4e14-4855-9ba7-ee89b1b91af4',
                                'main_project': '04c38783-0e09-4532-91a1-1b10bf7c8c83',
                                'zambia': 'c9d0eefd-3587-4fef-b5e1-6bdc75048f6c',
                                'namibia': '7ed49e4c-fde5-469e-b016-b989cb84a8ea',
                                'ghana': '58593c53-1215-4acb-8f80-daeb75d8398f',
                                'ivorycoast': '3cbff4a9-a076-4adf-9fa7-fa0940e20abd', // Côte d'Ivoire
                                'accessbank': 'b694a672-d2bf-4053-9ef8-eca0971c7b71',
                                'ssa': '7ed49e4c-fde5-469e-b016-b989cb84a8ea',
                                'absa': 'b879245a-c467-4206-83d4-e3d20819e3d8', // South Africa
                                'cameroon': '2c3a79fd-c238-464e-889e-02183616381c',
                                'senegal': '4936d005-b8b4-4a49-8464-edb1d0bf37e8',
                                'visazimsmereward': '8b676926-b0eb-44bb-b771-3f6463573955', // Zimbabwe
                                'mywelcomepickups': '44010610-8fa6-4a93-a866-6e22e7fd73ec', // Malaysia
                                'guinea': '625cf669-4fe1-4697-b42b-be10a954c5dc',
                                'benin': '399ff55b-54c8-4204-90a8-9cd36e444ac9',
                                'drc': '3ed81f05-574a-4acd-8ae8-bd063a7cb752', // Democratic Republic of the Congo
                                'capeverde': 'c9b97aa7-e322-4940-8856-9cfcd6bba5e0', // Cape/Cabo Verde
                                // COMMENT - add Project ID here for future projects
                            },
                            "sandbox": {
                                'client_id': '3825376c-4e14-4855-9ba7-ee89b1b91af4',
                                'main_project': '04c38783-0e09-4532-91a1-1b10bf7c8c83',
                                // 'sub_project': 'a6a55986-d69d-4b91-ab5f-4168c787c9ab'
                            },
                            "default_card_type": 'credit'
                    },
                    "email_needed": false,
                    "homepage_needed": true,
                    "search_type": 1,
                    "desktop_category_count": 5,
                    "bin_login": this.isVisaJP(selectedCountry) ? false : true,
                    "card_num_type": this.isVisaJP(selectedCountry) ? 'first8' : 'first9',
                    "card_type": "",
                    "tabs_type": "subcategory",
                    "tabs_type_mobile": "subcategory",
                    "has_exclusive": false,
                    "banner_type": "static",
                    "login_button_needed": true,
                    "loginAt": "card",
                    "login_theme": 1,
                    "login_steps":  this.isVisaJP(selectedCountry) ? ['card','mobile'] : ['card'],
                    "auto_expiry": {
                        "time" : "",
                        "enabled" : false
                    },
                    "template" : 1,
                    "header_type": "default",
                    "show_saving_for_bundle_codes": {},
                    "download_app_link": {
                        'header': false,
                        'footer': false,
                        'android_link': '',
                        'apple_link': ''
                    },
                    "login_modal_type": "card-mobile-otp",
                    "supported_devices": ['web','mobile'],
                    "benefits":['offers'],
                    "banner_style": 1,
                    "carouselInterval": -1,
                    "api_version": 'v2',
                    "personalized_config": {
                        "switch_card": true,
                        "autocard_check": false,
                        "external_otp": false,
                        "redemption_page_needed": true,
                        "resend_allowed": true,
                        "add_new_card": true,
                        "footer_logo": false,
                        "force_auth": true,
                        "token_auth": false,
                        "desktop_search": true,
                        "mobile_search": true,
                        "auth": true,
                        "coupon_modal": true,
                        "modal_redeem_button": true,
                        "mobile_home_back_button": true,
                        "show_card_used": true,
                        "show_bundle_used": false,
                        "allow_user_create": true,
                        "dedicated_banner": false,
                        "mobile_banner": true,
                        "authenticate_before_claim": true,
                        "disclaimer_popup": true,
                        "cancelable_auth": true,
                        "display_bundle_category_title": false,
                        "mobile_login": true,
                        "is_concierge": false,
                        "has_card": true,
                        "home_subcategory_dropdown": false,
                        "home_subcategory_bar": false,
                        "has_near_by": false,
                        "mobile_profile_dropdown": true,
                        "category_page": true,
                        "authenticate_bin": true,
                        "datalayer": false,
                        "has_add_card_text": false,
                        "mandatory_email": false,
                        "auto_location_detect": false
                    },
                    "subProjectLinks": [
                        'zambia',
                        'namibia',
                        'ghana',
                        'ivorycoast',
                        'accessbank',
                        'ssa',
                        'absa',
                        'cameroon',
                        'senegal',
                        'visazimsmereward',
                        'mywelcomepickups',
                        'guinea',
                        'benin',
                        'drc',
                        'capeverde'
                    ],
                    "specialProjectConfig": {
                        "zambia":{
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "namibia": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "ghana": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "ivorycoast": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "accessbank": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "ssa": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "absa": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "cameroon": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "senegal": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "visazimsmereward": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        "mywelcomepickups": {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        'guinea': {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        'benin': {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        'drc': {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                        'capeverde': {
                          "giftCodeInputModalTitle": "Enter The Entitlement Code You Received From your bank",
                          "giftCodeInputInputTitle": "Entitlement Code",
                          "invalidCodeMsg": "Entitlement code entered is invalid, please enter a valid code"
                        },
                      },
                    "titles": {
                        "homepage_pagetitle": "Offers & Privileges",
                        "homepage_description": "",
                        "homepage_keywords": "",
                        "header_title": "",
                        "modal_mobile_label": $localize`Enter your mobile number to proceed`,
                        "modal_email_label": $localize`Enter your email address(optional)`,
                        "card_name" : "Visa Commercial Card",
                        "platform_title": "SME Offers",
                        "concierge_name": "SME Offers",
                        "login_modal_control": $localize`Opt in to receive offers & benefits for`
                    },
                    "footer_additional_content": "<p>Disclaimer: SME Offers is a platform for communication of personalized offers extended by Merchants to Visa's Customers. Visa is only communicating the offers extended by Merchants to its Customers and not Selling/Rendering any of these Products/Services. Visa is neither guaranteeing nor making any representation. Visa is not responsible for Sale/Quality/Features of the Products/Services under the offers</p><p>Site is best viewed in Chrome V23+, Firefox V15+, Safari 6+ and Edge at 1024 x 768 pixels resolution, or above.</p>",
                    "content":{
                        "bin_error": {
                            "first4_last4": $localize`Dear Customer, the combination of your mobile number and the first 8 digits of your Card number did not get validated. Please try again.`,
                            "first6": $localize`Dear customer, please re-check the first 6 of your card number you have entered`,
                            "first8": $localize`Dear customer, please enter a Visa Commercial Card number`,
                            "first9": `Dear customer, please enter a Visa Commercial Card number`
                        }
                    },
                    "email": {
                        display: 'support-poshvine@razorpay.com', val: 'support-poshvine@razorpay.com'
                    },
                };
                break;
            default:
                this.router.navigate(['404']);
                break;
        }
    }

    private isVisaJP(selectedCountry) {
        return this.locale === 'ja' || selectedCountry?.iso2_code === 'JP'
    }
}
